export default "__VITE_ASSET__B_V$$g$6__"